import { useNavigationRules } from 'hooks/useNavigationRules'

export const PATH_CHART_ROUTER =
  '/projects/:projectUrlName/flows/:flowProjectLocalId/traces/:traceProjectLocalId'

export const PsChartRouter = () => {
  useNavigationRules()
  return null
}
